// extracted by mini-css-extract-plugin
module.exports = {"popupContainerStyle":"styles_popupContainerStyle__2n3y2"};